import animations from 'Assets/js/modules/animations';
import jsUtils from '@pernod-ricard-global-cms/jsutils';
import axios from "axios";

const getCookieValue = (name) =>
	document.cookie
		.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')
		?.pop() || '';

export default function heroHalfscreen(options = {}) {
  try {
    const { block } = options;
    jsUtils.loadCss(block.dataset.assetkey, options).then(() => {
      if (block.dataset.colour_filter !== 'none') {
        // Set CSS variable
        document.body.style.setProperty(
            '--hero-halfscreen-opacity',
            +block.dataset.colour_filter_opacity / 100
        );
      }

      // Sign In content
      const signInContent = block.querySelector(
          '.sign-in__content'
      );
      // Reveal Code
      const revealCode = block.querySelector(
          '.btn-reveal-code'
      );
      // Enter Competition
      const enterCompetition = block.querySelector(
          '.hero-competition__content'
      );

      const auth_cookie = document.getElementById('auth_cookie');
      if (auth_cookie && getCookieValue(auth_cookie.value) === '') {
        // Sign Up Cta
        const signUpCta = block.querySelector(
            '#signUpCta'
        );

        revealCode ? revealCode.remove() : null;
        enterCompetition ? enterCompetition.remove() : null;

        if (signUpCta) {
          signUpCta.addEventListener('click', (event) => {
            event.preventDefault();
            document.cookie = `redirection=${event.target.dataset.redirect}; path=/`;
            window.location.href = event.target.getAttribute("href");
          });
        }
      } else {
        signInContent ? signInContent.remove() : null;
      }

      if (enterCompetition) {
        //Hide completed fields
        let personalDetails = document.getElementsByClassName('competition_entry_area')[0];
        if (personalDetails) {
          personalDetails.style.display = 'none';
        }
      }

      animations.fadeIn(block);
      // Add your Javascript code here...

      const videoBlock = block.querySelector('.hero-halfscreen__video video');

      if (videoBlock === null || videoBlock === undefined) {
        return;
      }

      // just video code here below
      const soundButton = block.querySelector(
          '.hero-halfscreen__sounds-control'
      );
      const soundButtonOn = soundButton.querySelector(
          '.hero-halfscreen__sounds-on'
      );
      const soundButtonOff = soundButton.querySelector(
          '.hero-halfscreen__sounds-off'
      );
      const soundLabelOn = soundButton.querySelector(
          '.hero-halfscreen__sound-label-on'
      );
      const soundLabelOff = soundButton.querySelector(
          '.hero-halfscreen__sound-label-off'
      );
      soundButton.addEventListener('click', () => {
        if (videoBlock.muted) {
          soundButtonOn.style.display = 'block';
          soundButtonOff.style.display = 'none';
          soundLabelOn.style.display = 'none';
          soundLabelOff.style.display = 'block';
        } else {
          soundButtonOn.style.display = 'none';
          soundButtonOff.style.display = 'block';
          soundLabelOn.style.display = 'block';
          soundLabelOff.style.display = 'none';
        }
        videoBlock.muted = !videoBlock.muted;
      });

      const playButton = block.querySelector('.hero-halfscreen__play-control');
      const playButtonOn = playButton.querySelector(
          '.hero-halfscreen__play-on'
      );
      const playButtonOff = playButton.querySelector(
          '.hero-halfscreen__play-off'
      );
      const playLabelOn = playButton.querySelector(
          '.hero-halfscreen__play-label-on'
      );
      const playLabelOff = playButton.querySelector(
          '.hero-halfscreen__play-label-off'
      );
      playButton.addEventListener('click', () => {
        if (videoBlock.paused) {
          playButtonOn.style.display = 'none';
          playButtonOff.style.display = 'block';
          playLabelOn.style.display = 'none';
          playLabelOff.style.display = 'block';
          videoBlock.play();
        } else {
          playButtonOn.style.display = 'block';
          playButtonOff.style.display = 'none';
          playLabelOn.style.display = 'block';
          playLabelOff.style.display = 'none';
          videoBlock.pause();
        }
      });
    });

    const signUpUserButton = document.getElementById('signUpUserButton');
    if (signUpUserButton) {
      signUpUserButton.addEventListener('click', (event) => {
        event.preventDefault();
        const email = document.getElementById('sign_up_user_email');
        const market_slug = document.getElementById('market_slug');
        signUpUser(email.value, market_slug.value);
      });
    }


    // datalayer GA4
    // Push search event to the dataLayer
    window.dataLayer = window.dataLayer || [];
    document.querySelectorAll('.hero-halfscreen a[href*="midletondistillerycollection.com"]').forEach(link => {
      link.addEventListener('click', (event) => {
        window.dataLayer.push({
          'event':'buy_now_click',
          'event_data':{
              'link_url': window.location.href
          }
        })
      });
    });

  
    // 
  } catch (error) {
    console.error(error);
  }

  async function signUpUser(email, market_slug) {
    const languageCode = market_slug;
    const site_url = document.getElementById('site_url');

    if (!email || !languageCode ) {
      return ;
    }

    try {
      let siteURL = site_url ? site_url.value : '';
      let apiEndPoint = ('/wp-json/api/members/v1/user-status/').replace(/["]+/g, '');
      let url = siteURL + apiEndPoint + `?email=${encodeURIComponent(email)}&market=${languageCode}`;
      const response = await axios.post(url, {}, {
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (response.status == 200) {
        checkUsersConnectsStatus(response.data.user_status, email);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function checkUsersConnectsStatus(status, email) {
    if (status === 'user exists') {
      let signUpUserFields = document.getElementById('sign_up_user');
      if (signUpUserFields) {
        signUpUserFields.style.display = "none";
      }

      let signInForm = document.getElementsByClassName('form__sign-up')[0];
      if (signInForm) {
        // signInForm.style.display = "unset";
        signInForm.classList.remove("hide");
        let emailField = document.getElementById('email');
        if (emailField) {
          emailField.value = email;
        }
      }

    } else if (status === "user does not exist") {
      let signUpUserFields = document.getElementById('sign_up_user');
      if (signUpUserFields) {
        // signUpUserFields.style.display = "none";
      }

      let registerUserURL = document.getElementById('register_user_url');
      if (registerUserURL) {
        window.location.href = registerUserURL.value + `?email=${encodeURIComponent(email)}`;
      }
    } else if (status === "user migrated") {
      let resetPasswordURL = document.getElementById('reset_password_url');
      if (resetPasswordURL) {
        window.location.href = resetPasswordURL.value + `?email=${encodeURIComponent(email)}`;
      }
    }

  }
}
